import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  MenuItem,
  FormControl,
  Select,
  Chip,
  Divider,
  Paper,
  Grid,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import {
  TextFields as TextIcon,
  Image as ImageIcon,
  Description as DocumentIcon,
  Videocam as VideoIcon,
  Reply as ReplyButtonsIcon,
  LocationOn as LocationIcon,
  ListAlt as InteractiveListIcon,
  Map as LocationRequestIcon,
  Link as InteractiveCTAIcon,
  Terminal as EndpointIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import SectionLabel from "../../../widgets/SectionLabel";

const messageOptions = [
  { value: "text", label: "Text", icon: <TextIcon /> },
  { value: "image", label: "Image", icon: <ImageIcon /> },
  { value: "document", label: "Document", icon: <DocumentIcon /> },
  { value: "video", label: "Video", icon: <VideoIcon /> },
  {
    value: "reply_buttons",
    label: "Reply Buttons",
    icon: <ReplyButtonsIcon />,
  },
  { value: "location", label: "Location", icon: <LocationIcon /> },
  {
    value: "list",
    label: "Interactive List",
    icon: <InteractiveListIcon />,
  },
  {
    value: "location_request_message",
    label: "Location Request",
    icon: <LocationRequestIcon />,
  },
  {
    value: "interactive_cta_urls",
    label: "Interactive CTA",
    icon: <InteractiveCTAIcon />,
  },
  { value: "endpoint", label: "Endpoint", icon: <EndpointIcon /> },
  { value: "chatform", label: "Chat Form", icon: <DynamicFormIcon /> },
  { value: "template", label: "Template", icon: <FindReplaceIcon /> },
];

const MessageSelector = ({ value, onChange }) => {
  const selectedOption = value || "";
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const getSelectedOptionData = () => {
    return messageOptions.find((option) => option.value === selectedOption);
  };

  return (
    <>
      <SectionLabel mb={1}>Message Type Selector</SectionLabel>
      <FormControl size="small" fullWidth>
        <Select
          size="small"
          className="nodrag"
          value={selectedOption}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return (
                <Typography color="text.secondary">
                  Select a message type
                </Typography>
              );
            }
            const option = getSelectedOptionData();
            return (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {option.icon}
                <Typography>{option.label}</Typography>
              </Box>
            );
          }}
          sx={{ mb: 3 }}
        >
          <MenuItem disabled value="">
            <Typography color="text.secondary">
              Select a message type
            </Typography>
          </MenuItem>
          {messageOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
MessageSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

MessageSelector.defaultProps = {
  value: "",
};
export default MessageSelector;
